export default {
  app: {
    title: 'Transfer Service',
    subtitle: 'Booking, order lookup, and payment status',
    language: 'Language'
  },
  common: {
    ok: 'OK',
    systemError: 'System error'
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you opened does not exist. The link may have expired or the address may be incorrect.'
  },
  action: {
    booking: 'Book a ride',
    queryOrder: 'Find order',
    submit: 'Submit',
    continue: 'Continue',
    cancel: 'Cancel',
    backHome: 'Back home',
    expand: 'Expand',
    collapse: 'Collapse',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No'
  },
  booking: {
    title: 'Book a ride',
    successTitle: 'Booking submitted',
    successDescription: 'Please keep your order number and query code. You can look up the order with your order number, email, and query code.',
    successOrderNo: 'Order number',
    successQueryCode: 'Query code',
    customerInfo: 'Customer information',
    appointments: 'Trip appointments',
    multiAppointmentHint: 'One order can include multiple trip appointments.',
    appointmentTitle: 'Appointment {index}',
    basicInfo: 'Basic information',
    flightAndAddress: 'Flight and address',
    extraServices: 'Extra services',
    addAppointment: 'Add appointment',
    addTripDetail: 'Add trip detail',
    snowboardHint: 'Hiace is recommended for 4+ passengers with golf/ski bags.',
    babySeatLabel: 'Child seats ({free} free, {price} each from seat {from})',
    babySeatSimpleHint: '+¥1,500 each from the 2nd seat',
    supermarketPriceItem: '{hour} hour(s) {price}',
    tripEstimate: 'Trip estimate',
    totalEstimate: 'Order estimate total',
    priceBreakdown: {
      baseFare: 'Base fare',
      earlyLateSurcharge: 'Early/late surcharge {percent}',
      babySeat: 'Child seats',
      supermarketStop: 'Supermarket stop'
    },
    verifyEmailAndContinue: 'Verify email and continue',
    sendEmailCode: 'Send email code',
    resendEmailCode: 'Resend code',
    resendCountdown: 'Resend in {seconds}s',
    emailCodeSent: 'Verification code sent. Please enter the email code.',
    emailVerified: 'Email format verified',
    emailVerificationTitle: 'Email verification',
    emailVerificationDescription: 'Send the email verification code and verify it before submitting your booking.',
    verifyAndSubmit: 'Verify and submit',
    carInfo: 'Car information',
    field: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      verifyCode: 'Verification code',
      serviceType: 'Route',
      date: 'Date of service',
      product: 'Product',
      transferRoute: 'Transfer route',
      carType: 'Car type',
      passengers: 'Passengers',
      luggage: 'Total amount of luggage',
      snowboard: 'Golf/Ski bag',
      flightNo: 'Flight number',
      flightTime: 'Flight time',
      arrivalTime: 'Arrival time',
      departureTime: 'Departure time',
      pickupAddress: 'Pick-up Place',
      meetingPlace: 'Meeting place',
      dropoffAddress: 'Destination',
      customDropoffAddress: 'Custom destination',
      tripDetails: 'Trip details',
      tripDetailTitle: 'Trip detail {index}',
      remark: 'Remark',
      supermarketStop: 'Supermarket stop'
    },
    unit: {
      pieces: '{count} pcs'
    },
    airportTerminal: {
      international: 'International terminal',
      domestic: 'Domestic terminal'
    },
    serviceType: {
      airportPickup: 'Trip from airport',
      airportDropoff: 'Trip to airport',
      pointToPoint: 'Transfer route list'
    },
    supermarketOption: {
      none: 'No stop',
      oneHour: '1 hour',
      twoHours: '2 hours',
      threeHours: '3 hours'
    },
    surchargeHint: {
      pickup: 'Trips before {before} or after {after} require a {percent} surcharge.',
      departure: 'Trips departing before {before} or after {after} require a {percent} surcharge.'
    },
    validation: {
      nameRequired: 'Please enter your name',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Please enter a valid email address',
      emailNotVerified: 'Please verify your email first',
      emailCodeNotSent: 'Please send the email verification code first',
      verifyCodeInvalid: 'Invalid verification code',
      verifyCodeInvalidRetry: 'The verification code is incorrect or expired. Please resend the code and verify again.',
      phoneRequired: 'Please enter your phone number',
      dateRequired: 'Appointment {index}: please select a date',
      noAvailablePricePeriod: 'Appointment {index}: this product has no valid price period from today',
      dateOutOfPricePeriod: 'Appointment {index}: selected date is outside the product price period',
      productRequired: 'Appointment {index}: please select a product',
      carTypeRequired: 'Appointment {index}: please select a car type',
      passengersRequired: 'Appointment {index}: please select the passenger count',
      passengersOverCarLimit: 'Appointment {index}: this car type supports up to {max} passengers',
      flightNoRequired: 'Appointment {index}: please enter the flight number',
      timeRequired: 'Appointment {index}: please enter {field}',
      pickupAddressRequired: 'Appointment {index}: please enter the pickup address',
      dropoffAddressRequired: 'Appointment {index}: please enter the destination',
      tripDetailRequired: 'Appointment {index}: please enter trip detail',
      tripDetailMaxLength: 'Appointment {index}: please enter trip detail within 500 characters'
    }
  },
  order: {
    queryTitle: 'Find order', // 查询订单
    detailTitle: 'Order detail', // 订单详情
    tokenQueryDescription: 'Enter your booking lookup token. If it is valid, the booking detail page will open.',
    tokenPlaceholder: 'Enter booking lookup token',
    checking: 'Checking...',
    invalidTitle: 'Booking link invalid or expired',
    invalidDescription: 'No matching booking was found, or this lookup token has expired. Please check that the token is complete or contact staff for a new one.',
    orderInfo: 'Order information', // 订单信息
    orderStatus: 'Order status', // 订单状态
    paymentStatus: 'Payment status', // 支付状态
    loading: 'Loading order detail...', // 正在加载订单详情...
    tripItems: 'Trip items', // 行程明细
    sendVerifyCode: 'Get verification code', // 获取验证码
    verifyAndViewDetail: 'Verify and view order',
    resendCode: 'Resend', // 重新获取
    resendCountdown: 'Resend in {seconds}s', // {seconds} 秒后重新获取
    verifyCodeSent: 'A verification code has been sent to your booking email.', // 验证码已发送，请查看预约邮箱。
    forgotVerifyCode: 'Forgot your verification code?',
    mockVerifyCodePlaceholder: '',
    field: {
      orderNo: 'Order number', // 订单号
      email: 'Email', // 邮箱
      verifyCode: 'Verification code', // 验证码
      token: 'Lookup token'
    },
    detail: {
      orderNo: 'Order number',
      appointmentId: 'Reservation ID',
      customerInfo: 'Customer information',
      basicInformation: 'Basic information',
      flightAndAddress: 'Flight and address',
      extraServices: 'Extra services',
      dateOfService: 'Date of service',
      carTypeMinMax: 'Car type(Min～Max)',
      passengerCount: 'The number of passenger',
      totalLuggage: 'Total amount of luggage',
      snowboard: 'Golf/Ski bag',
      flightNumber: 'Flight number',
      flightTime: 'Flight time',
      meetingPlace: 'Meeting place',
      destination: 'Destination',
      seat: 'Seat',
      supermarketStop: 'Supermarket stop',
      deliveryInfo: 'Vehicle dispatch information',
      deliveryStatus: 'Dispatch status',
      dispatched: 'Dispatched',
      notDispatched: 'Not dispatched',
      driverInfoVisibleSoon: 'Dispatched. Driver and vehicle details will be shown 3 days before departure.',
      vehicle: 'Vehicle',
      licensePlate: 'Plate number',
      driver: 'Driver',
      phone: 'Phone',
      estimatedArrival: 'Estimated arrival',
      waitingPlace: 'Waiting place'
    },
    validation: {
      orderNoRequired: 'Please enter the order number', // 请输入订单号
      emailRequired: 'Please enter your email', // 请输入邮箱
      verifyCodeRequired: 'Please enter the verification code', // 请输入验证码
      tokenRequired: 'Please enter the lookup token'
    },
    status: {
      0: 'Pending confirmation',
      1: 'Confirmed',
      pending: 'Pending confirmation', // 待确认
      confirmed: 'Confirmed', // 已确认
      quoted: 'Quoted', // 已报价
      cancelled: 'Cancelled', // 已取消
      completed: 'Completed', // 已完成
      unknown: 'Unknown status' // 未知状态
    },
    info: {
      startDate: 'Start date', // 开始日期
      companyId: 'Agency ID', // 代理店ID
      bidStartTime: 'Bid start time', // 入札开始时间
      paymentAmount: 'Payment amount', // 支付金额
      paymentEmail: 'Payment email', // 支付邮箱
      paymentEmailName: 'Payment email name', // 支付邮箱姓名
      paymentTaskId: 'Payment task ID', // 支付任务ID
      paymentUrl: 'Payment link', // 支付链接
      paymentStripePid: 'Stripe payment ID', // Stripe 支付ID
      creator: 'Creator', // 创建者
      createTime: 'Created at', // 创建时间
      updater: 'Updater', // 更新者
      updateTime: 'Updated at', // 更新时间
      branch: 'Appointment branch', // 预约分支
      copyBranch: 'Copy branch', // 复制分支
      carType: 'Car type', // 车种
      people: 'people', // 人
      passengers: 'Passengers', // 乘客人数
      flight: 'Flight & number', // 航班及号码
      flightDepartureTime: 'Flight departure time', // 航班出发时间
      arrivalTime: 'Flight arrival time', // 班机抵达时间
      departureTime: 'Departure time', // 出发时间
      boardAddress: 'Boarding address', // 上车地点
      destination: 'Destination', // 目的地
      customerName: 'Customer name', // 客户姓名
      customerPhone: 'Customer phone', // 客户电话
      customerEmail: 'Customer email', // 客户邮箱
      babySeat: 'Baby seat', // 儿童座椅
      remark: 'Remark', // 备注
      amount: 'Amount', // 金额
      cancelFee: 'Cancellation fee' // 取消费用
    },
    appointmentCount: '{count} appointments', // {count} 个预约
    noAppointments: 'This order has no appointment details yet.', // 此订单暂未包含预约明细。
    feeDetails: 'Fee details', // 费用明细
    invoiceNo: 'Invoice number', // 发票编号
    payNoticeNo: 'Payment notice number', // 付款通知编号
    carrierInvoiceNo: 'Carrier invoice number', // 承运商发票编号
    processStatus: 'Process status', // 处理状态
    sellPrice: 'Sell price', // 卖价
    grossPrice: 'Gross price', // 总价
    netPrice: 'Net price', // 净价
    fee: 'Fee', // 手续费
    otherFee10: 'Other fee (10%)', // 其他费用 (10%)
    otherFee8: 'Other fee (8%)', // 其他费用 (8%)
    administratorMemo: 'Admin memo' // 管理员备注
  },
  payment: {
    title: 'Bill and payment',
    billNumber: 'Bill number',
    billDate: 'Bill date',
    deadline: 'Bill deadline',
    receivedDate: 'Payment received date',
    totalFee: 'Total fee',
    currentBillAmount: 'Current bill amount',
    orderTotalAmount: 'Order total',
    amountToPayNow: 'Amount due now',
    amountToPayNowHint: 'A new Stripe payment page will be created for this amount when you pay.',
    paidAmount: 'Paid amount',
    unpaidAmount: 'Unpaid amount',
    refundAmount: 'Refund due',
    refundAmountPending: 'Refund due',
    refundAmountRefunded: 'Refunded amount',
    refundAmountPartial: 'Partially refunded amount',
    appointmentAmount: 'Appointment amount',
    appointmentFeeDetails: 'Fee details by appointment',
    originalAppointmentAmount: 'Original appointment amount',
    cancelFee: 'Cancellation fee',
    cancelStatus: 'Cancellation status',
    cancelStatusBeforePayment: 'Canceled before payment, no payment or refund needed',
    cancelStatusPaymentRequired: 'Cancellation fee payment required',
    cancelStatusAfterPaymentNoRefund: 'Canceled after payment, no refund due',
    cancelStatusRefundPending: 'Canceled after payment, refund due',
    cancelStatusPartialRefunded: 'Canceled after payment, partially refunded',
    cancelStatusRefunded: 'Canceled after payment, refunded',
    remark: 'Remark',
    downloadInvoice: 'Download bill',
    payNow: 'Pay now',
    collectByHotel: 'Please pay the fee to the hotel or travel agency.',
    collectByDriver: 'Please pay the fee to the driver.',
    downloadSuccess: 'Bill downloaded successfully',
    paymentUrlEmpty: 'Payment link was not returned',
    status: {
      0: 'Unpaid',
      1: 'Paid',
      2: 'Payment failed',
      not_requested: 'Not requested',
      unpaid: 'Unpaid',
      pending: 'Payment pending',
      paid: 'Paid',
      timeout: 'Payment timeout',
      additionalRequired: 'Additional payment required',
      partial: 'Partially paid',
      failed: 'Payment failed',
      expired: 'Expired',
      refunded: 'Refunded',
      unknown: 'Unknown status'
    }
  },
  message: {
    title: 'Message / Contact us',
    description: 'If you need to update trip details or ask about payment, leave a message here.',
    field: 'Message',
    target: 'Message target',
    orderTarget: 'Whole order',
    itemTarget: 'Trip {index}',
    itemMessageButton: 'Message this trip',
    placeholder: 'Enter your message',
    submit: 'Submit message',
    close: 'Close',
    history: 'Messages and replies',
    empty: 'No messages yet',
    customer: 'My message',
    staff: 'Staff reply',
    validationRequired: 'Please enter a message',
    maxLengthExceeded: 'Message must be {max} characters or fewer',
    submitSuccess: 'Message submitted'
  },
  policy: {
    eyebrow: 'Notice & Policy',
    title: 'Notice',
    description: '【Madoras-Private Transfer】',
    noticeTitle: '',
    cancelTitle: 'Reservation Change/Cancellation Policy',
    noticeItems: [
      '1.1 Reservation Deadline: The deadline is 7 days before the travel date.',
      '1.2 Handling Charge: A handling charge is required for any changes or cancellations made within 7 days before the travel date, per the Reservation Change/Cancellation Policy outlined below.',
      '1.3 Incorrect Information: Please ensure all details provided are accurate. Madoras will arrange transportation based on the information provided. If incorrect details lead to misarrangement and payment has been made, NO REFUND IS AVAILABLE.',
      "1.4 No Show: If Madoras's driver attempts to locate the client, but the client does not show up, NO REFUND IS AVAILABLE.",
      '1.5 Payment: To make payment as early as possible is recommended. Because it takes time, sometimes several days to confirm the payment. And we will start to arrange your transfer after we confirmed your payment. So, the early remittance is recommended.',
      '1.6 Meeting Point: Depending on passenger numbers, clients may need to attend a specific meeting point. Details will be provided in the confirmation email.',
      '1.7 Delays/Cancellations: Private transfers may be delayed or canceled due to weather, traffic, road conditions, or any other force majeure events. In such situations, NO REFUND IS AVAILABLE.',
      '1.8 Flight Cancellations/Delays: Even though your flight has been cancelled or delay, you do not contact us. It will be considered a no-show and no refund.\nIn the event of a flight delay, please call us immediately. +81-11-215-1962\nWe will check whether we can hold the vehicle on site, arrange an alternative, or arrangements are not possible.\nIf you arrive late without contacting us, the vehicle may have already left for another reservation, and it will be considered a no-show and no refund.',
      '1.9 Seasonal Rate Changes: Fees may vary based on high or low seasons. The listed price is applicable before the 7-day deadline. Last-minutes request may be charged at least 20% additional charge.',
      '1.10 Early-morning and Late-night Charge: A 20% additional charge applies for early morning and late-night transfers.\n・Early-morning: Pickup earlier than 6:30 a.m.\n・Late-night: Flight arrival later than 9:30 p.m.',
      '1.11 Stopovers: If you request stopovers, we will estimate the new itinerary and provide the updated price separately.',
      '1.12 Price Change Notice: Madoras may change prices, especially in high or low seasons.'
    ],
    cancelItems: [
      'Please be sure to contact us by email or phone during our business hours. In that case, please email info@madoras.net  Or +81-11-252-9966\nWe are unable to respond to emails sent to booking@madoras.net. This is a receive-only email address.',
      'Standard Response Time: We will respond if you contact us during our office hours (9:00 a.m. – 6:00 p.m.). Any inquiries received after this time will be handled on the following business day.',
      'Cancellation Schedule / Handling Charge:',
      'From 7 days to 2 days before the travel date: 30%',
      'Before 12:00 noon on the day before the travel date: 50%',
      'After 12:00 noon on the day before, or on the travel date: 100%',
      '4.If you would like to change your booking during 7 days period before the trip date, you need to cancel the original booking and make a new one. The handling charge is required',
      '5. After less than 7 days until your trip date, we will charge the cancellation fee above for not only cancellation but also for changing the booking.',
      '6.If you cancel 7 days before the travel date, you will get a full refund, but a 6% handling charge is required.',
      'Thank you very much and best regards.'
    ]
  },
  error: {
    title: 'Unable to continue',
    requestFailed: 'Request failed. Please try again later.',
    orderCredentialMismatch: 'The order number and email do not match. Please check and try again.',
    invalidVerifyCode: 'The verification code is incorrect. Please try again.',
    verifyCodeTooFrequent: 'Please wait before sending the verification code again.',
    orderNotFound: 'Order not found. Please check the order number and email.',
    bookingTokenInvalid: 'This order link is invalid or expired. Please check the link or contact staff for a new one.',
    invoiceNotAvailable: 'The bill can be downloaded after payment is completed.',
    invoiceGenerateFailed: 'Unable to generate the bill. Please try again later or contact staff.'
  }
}
